<template>
  <div class="ineligible-dialog">
    <el-dialog
      :title="ineligibleDialogTitle"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="420px"
      center>
      <div class="content">
        {{ineligibleTipContent}}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="cancel-button" @click="cancel">{{$t('quotes.cancel')}}</el-button>
        <el-button type="confirm-button" @click="gotohandle">{{btns[1].text}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    ineligibleDialogTitle: {
      type: String,
      default: () => ''
    },
    ineligibleTipContent: {
      type: String,
      default: () => ''
    },
    btns: {
      type: Array,
      default: () => [
        {
          text: this.$t('quotes.cancel'),
          handle: 'cancel'
        },
        {
          text: this.$t('quotes.toDeposit'),
          handle: 'toDeposit'
        }
      ]
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('update:dialogVisible', false)
    },
    gotohandle () {
      if (this.btns[1].handle === 'toDeposit') {
        this.toDeposit()
      } else {
        this.toAccountrading()
      }
    },
    toDeposit () {
      this.$router.push({
        path: '/deposit'
      })
    },
    toAccountrading () {
      this.$router.push({
        path: '/other-account'
      })
    }
  }
}
</script>
<style lang="scss">

.ineligible-dialog {
  .el-dialog--center {
    height: 200px !important;
  }
  .el-dialog__body {
    padding-top: 0px;
  }
  .el-dialog__title {
    font-size:18px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(12,32,69,1);

  }
  .content {
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    text-align: center;
    color:#7D7D7D;
    // line-height:20px;
  }
  .dialog-footer {
    display: flex;
    .el-button{
      display: block;
      margin: 0px 20px 0 auto;
      width:250px;
      height:56px;
      border-radius:5px;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(25,43,87,1);
      line-height:20px;
      &:last-of-type{
        margin-right: 0;
      }
    }
    .el-button--confirm-button {
      background:rgba(254,192,0,1) !important;
    }

  }
}
</style>
